import copy from 'clipboard-copy'
import { call, takeLatest } from 'redux-saga/effects'

import { toast } from '../../notifications'

import { copyToClipboard } from './actions'

const COPY_SUCCESS_MESSAGE = 'in die Zwischenablage kopiert'
const COPY_FAILURE_MESSAGE = 'konnte nicht in die Zwischenablage kopiert werden'

export function * copyToClipboardExecutor (
  {
    payload: {
      content,
      description
    },
    meta: {
      successMessage = `${description} ${COPY_SUCCESS_MESSAGE}`,
      failureMessage = `${description} ${COPY_FAILURE_MESSAGE}`
    } = {}
  }
) {
  try {
    yield call(copy, content)
    toast.info(successMessage)
  } catch (e) {
    console.warn(e)
    toast.error(failureMessage)
  }
}

export default takeLatest(copyToClipboard, copyToClipboardExecutor)
